import {
  mapFromClassification,
  mapFromClassifications,
  mapToClassification,
  mapToClassifications,
} from 'mappings/classificationMapping';
import Classification from 'models/classification/classification';
import ClassificationDTO from 'models/dto/classification/classificationDTO';
import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import AppError from 'utils/appError';
import http from './httpService';

interface IGetClassificationsOptions {
  includeAllLanguages?: boolean;
}

export async function apiGetClassifications(
  accessToken: string,
  cache: GlobalDataCache,
  options?: IGetClassificationsOptions,
): Promise<Classification[]> {
  try {
    const includeAllLanguages = options?.includeAllLanguages ?? false;
    const ar = await http.get<ClassificationDTO[]>(
      `/classifications?includeAllLanguages=${includeAllLanguages}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromClassifications(ar.data, cache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiAddClassification(
  item: Classification,
  accessToken: string,
  cache: GlobalDataCache,
): Promise<Classification> {
  try {
    const itemDto = mapToClassification(item);
    const ar = await http.post<ClassificationDTO>(`/classifications`, itemDto, http.getRequestConfig(accessToken));

    return mapFromClassification(ar.data, cache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUpdateClassification(
  editClassification: Classification,
  accessToken: string,
  globalDataCache: GlobalDataCache,
): Promise<Classification> {
  try {
    const classificationDTO: ClassificationDTO = mapToClassification(editClassification);

    const ar = await http.put<ClassificationDTO>(
      `/classifications`,
      classificationDTO,
      http.getRequestConfig(accessToken),
    );

    return mapFromClassification(ar.data, globalDataCache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUpdateClassifications(
  classifications: Classification[],
  accessToken: string,
  globalDataCache: GlobalDataCache,
): Promise<Classification[]> {
  try {
    const classificationDTOs: ClassificationDTO[] = mapToClassifications(classifications) ?? [];

    const ar = await http.put<ClassificationDTO[]>(
      `/classifications/bulk`,
      classificationDTOs,
      http.getRequestConfig(accessToken),
    );

    return mapFromClassifications(ar.data, globalDataCache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiRemoveClassification(classification: Classification, accessToken: string): Promise<boolean> {
  try {
    await http.post(
      `/classifications/delete/${classification.classificationId}`,
      null,
      http.getRequestConfig(accessToken),
    );

    return true;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
